import React from 'react';
import { Github, Linkedin, Mail, Heart } from 'lucide-react';

const Footer = ({ personalInfo }) => {
  const currentYear = new Date().getFullYear();
  
  if (!personalInfo) return null;
  const handleEmailClick = () => {
  const subject = encodeURIComponent("Portfolio Inquiry");
  const body = encodeURIComponent(
    "Hi Harsha,\n\nI saw your portfolio and would like to connect."
  );

  const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  if (isMobile) {
    // Open native mail app
    window.location.href = `mailto:${personalInfo.email}?subject=${subject}&body=${body}`;
  } else {
    // Open Gmail web compose on desktop
    window.open(
      `https://mail.google.com/mail/?view=cm&fs=1&to=${personalInfo.email}&su=${subject}&body=${body}`,
      "_blank"
    );
  }
  };
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4">{personalInfo.name}</h3>
            <p className="text-gray-400 text-sm leading-relaxed">
              Computer Science researcher specializing in Vision Transformers, Efficient AI, and Safety-Critical Systems.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <a href="#about" className="text-gray-400 hover:text-white transition-colors">
                  About Me
                </a>
              </li>
              <li>
                <a href="#research" className="text-gray-400 hover:text-white transition-colors">
                  Research Projects
                </a>
              </li>
              <li>
                <a href="#publications" className="text-gray-400 hover:text-white transition-colors">
                  Publications
                </a>
              </li>
              <li>
                <a href="#experience" className="text-gray-400 hover:text-white transition-colors">
                  Experience
                </a>
              </li>
              <li>
                <a href="#contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Connect</h4>
            <div className="flex gap-4 mb-4">
              <a
                href={personalInfo.github}
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-gray-800 hover:bg-gray-700 rounded-lg transition-all transform hover:scale-110"
              >
                <Github size={20} />
              </a>
              <a
                href={`https://${personalInfo.linkedin}`}
                target="_blank"
                rel="noopener noreferrer"
                className="p-3 bg-gray-800 hover:bg-gray-700 rounded-lg transition-all transform hover:scale-110"
              >
                <Linkedin size={20} />
              </a>
              <div
                onClick={handleEmailClick}
                className="p-3 bg-gray-800 hover:bg-gray-700 rounded-lg transition-all transform hover:scale-110 cursor-pointer"
              >
                <Mail size={20} />
              </div>
            </div>
            <p className="text-gray-400 text-sm">
              <span
                onClick={handleEmailClick}
                className="hover:text-white transition-colors cursor-pointer"
              > 
                {personalInfo.email}
              </span>
            </p>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              © {currentYear} {personalInfo.name}. All rights reserved.
            </p>
            <p className="text-gray-400 text-sm flex items-center gap-2">
              Built with <Heart size={16} className="text-red-500" /> for showcasing research excellence
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
